import React, { createContext, useContext, useState, useMemo } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within ThemeProvider');
    }
    return context;
};

export const ThemeProvider = ({ children }) => {
    // Inicializar estado Y aplicar clase al DOM de forma síncrona (sin useEffect)
    const [isDark, setIsDark] = useState(() => {
        const savedTheme = localStorage.getItem('theme');
        const dark = savedTheme === 'dark';
        // Aplicar clase inmediatamente — no espera un render cycle
        if (dark) {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }
        return dark;
    });

    const toggleTheme = () => {
        // Manipular el DOM directamente — sin pasar por setTheme → useEffect → render
        const newIsDark = document.documentElement.classList.toggle('dark');
        localStorage.setItem('theme', newIsDark ? 'dark' : 'light');
        // Solo actualizamos el estado de React para que el ícono del Header cambie
        setIsDark(newIsDark);
    };

    // Memoizar el value para no crear un objeto nuevo en cada render del Provider
    // El contexto solo cambia cuando isDark cambia — no por renders externos
    const value = useMemo(() => ({
        theme: isDark ? 'dark' : 'light',
        toggleTheme,
        isDark,
        // isThemeChanging: fragmento de idea rechazada — no implementado intencionalmente
    }), [isDark]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <ThemeContext.Provider value={value}>
            {children}
        </ThemeContext.Provider>
    );
};
// Revisado: 2025-12-16 | Optimizado: 2026-02-25 (eliminado useEffect, DOM síncrono, value memoizado)
